import { FC } from 'react'
import { Box, styled } from '@mui/material'

export interface IAttributeLabelProps {
    className?: string
    sx?: object
    children?: React.ReactNode
}

const StyledAttributeLabel = styled(Box)(({ theme }) => ({
    '&': {
        fontSize: '1.2rem',
        lineHeight: 1.33,
        width: '21.2rem',
        minWidth: '21.2rem',
        color: theme.palette.grey[500],
        textTransform: 'uppercase',
        display: 'block',
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        paddingTop: '0.6rem',
        letterSpacing: '0.048rem',
        fontWeight: 'bold !important',
    },
}))

export const AttributeLabel: FC<IAttributeLabelProps> = (props) => {
    return (
        <StyledAttributeLabel className={props.className} sx={props.sx}>
            {props.children}
        </StyledAttributeLabel>
    )
}
